import * as Activity from "./components/PlotAPI/Activity";
import * as ApiKey from "./components/PlotAPI/ApiKey";
import * as Areas from "./components/PlotAPI/Area";
import * as Calendar from "./components/PlotAPI/Calendar";
import * as Comments from "./components/PlotAPI/Comments";
import * as Deliveries from "./components/PlotAPI/Delivery";
import * as DeliveryAttachments from "./components/PlotAPI/DeliveryAttachments";
import * as DeliveryAvailabilities from "./components/PlotAPI/DeliveryAvailabilities";
import * as Equipment from "./components/PlotAPI/Equipment";
import * as ExceptionDays from "./components/PlotAPI/ExceptionDays";
import * as FireTV from "./components/PlotAPI/FireTV";
import * as Integrations from "./components/PlotAPI/Integrations";
import * as Invite from "./components/PlotAPI/Invite";
import * as Login from "./components/PlotAPI/Login";
import * as MagicToken from "./components/PlotAPI/MagicToken";
import * as Map from "./components/PlotAPI/Map";
import * as MapObject from "./components/PlotAPI/MapObject";
import * as Material from "./components/PlotAPI/Material";
import * as MaterialGroup from "./components/PlotAPI/MaterialGroup";
import * as MaterialOld from "./components/PlotAPI/MaterialOld";
import * as Notifications from "./components/PlotAPI/Notifications";
import * as Order from "./components/PlotAPI/Order";
import * as OrderOld from "./components/PlotAPI/OrderOld";
import * as Procurement from "./components/PlotAPI/Procurement";
import * as Project from "./components/PlotAPI/Project";
import * as ProjectAttachments from "./components/PlotAPI/ProjectAttachments";
import * as Submittal from "./components/PlotAPI/Submittal";
import * as Team from "./components/PlotAPI/Team";
import * as Trade from "./components/PlotAPI/Trade";
import * as User from "./components/PlotAPI/User";
import * as Vendor from "./components/PlotAPI/Vendor";
import * as Weather from "./components/PlotAPI/Weather";

const PlotAPI = {
    ...Activity,
    ...ApiKey,
    ...Areas,
    ...Calendar,
    ...Comments,
    ...Deliveries,
    ...DeliveryAttachments,
    ...DeliveryAvailabilities,
    ...Equipment,
    ...ExceptionDays,
    ...FireTV,
    ...Integrations,
    ...Invite,
    ...Login,
    ...MagicToken,
    ...Map,
    ...MapObject,
    ...Material,
    ...MaterialGroup,
    ...MaterialOld,
    ...Notifications,
    ...Order,
    ...OrderOld,
    ...Procurement,
    ...Project,
    ...ProjectAttachments,
    ...Submittal,
    ...Team,
    ...Trade,
    ...User,
    ...Vendor,
    ...Weather,
};

export default PlotAPI;
